<div class="modal-content m-0">
  <div class="modal-header">
    <p class="modal-title">{{ 'results.search.title' | translate }}</p>
    <i class="fa-light fa-xmark ms-auto cursor-pointer" (click)="dismiss()"></i>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-12">
        <div class="row align-items-center mb-3">
          <div class="col-12 col-sm-3 label">
            {{ 'results.search.form.kitToken' | translate }}
          </div>
          <div class="col-12 col-sm-9">
            <input
              type="text"
              class="form-control w-100"
              [formControl]="kitTokenControl"
              [placeholder]="
                'results.search.form.placeholders.barcode' | translate
              "
            />
          </div>
        </div>
        @if (kitTokenControl.dirty && kitTokenControl.errors?.required) {
          <div class="row">
            <div class="offset-sm-3 col-12 col-sm-9">
              <span class="caption text-danger">
                {{ 'validation.generic.required' | translate }}
              </span>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-primary"
      [disabled]="kitTokenControl.invalid || loading()"
      (click)="search()"
    >
      {{ 'results.search.form.button' | translate }}
    </button>
  </div>
</div>
